export const DialogueTypes = {
  Price: 'Price',
  Quantity: 'Quantity'
};
